'use client'

import React, { useRef } from 'react'

import { GeneralInformation } from '@/payload-types'
import { HttpTypes } from '@medusajs/types'
import { Media } from '../Media/Media'
import Link from 'next/link'
import CartButton from './CartButton'
import { NavItem } from './NavItem'
import { UserMenu } from './UserMenu'
import SearchButton from './SearchBar/SearchButton'
export const HeaderNav: React.FC<{
  data: GeneralInformation
  customer: HttpTypes.StoreCustomer | null
}> = ({ data, customer }) => {
  const { navigationItems, logo } = data || []
  const headerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <nav
        id="nav-bar"
        ref={headerRef}
        className="
            fixed top-0 left-0 w-full z-1000
            lg:flex lg:flex-row
            justify-between items-center
            py-3
            backdrop-blur-md bg-white/20 border border-white/30 shadow-lg
            hidden mb:block
          "
      >
        <div className="mx-auto">
          <div className="flex items-center justify-cetween gap-10">
            {logo && (
              <Link href="/" aria-label="Accueil">
                <Media resource={logo} className="w-16" />
              </Link>
            )}
            {navigationItems &&
              navigationItems.map((navItem) => {
                if (!navItem.linkWithMedia) return null

                return <NavItem key={navItem.id} navItem={navItem} />
              })}

            <div className="flex items-center gap-3">
              <SearchButton />

              <UserMenu customer={customer} />

              <CartButton />
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
